export const uploadedVideo = {
  acquiring: "请求中",
  camera: "摄像头",
  completed: "完成",
  deleteTip: "所选的记录将被删除。确定要继续吗？",
  download: "查看",
  driver: "操作员",
  DSS: "驾驶行为",
  duration: "时长",
  failed: "失败",
  fleet: "车间",
  front: "前方",
  left: "左方",
  notes: "备注",
  rear: "后方",
  right: "右方",
  speed: "速度",
  uploading: "上传中",
  uploadStatus: "上传状态",
  uploadTime: "上传时间",
  vehicle: "设备",
  videoSize: "视频大小",
  videoTime: "开始时间",
  partialDone: "部分完成",
  invalidURL: "链接无效",
};
